import { Seo } from "@/components/site/Seo";
import { CtaLink } from "@/components/site/Primitives";
import { NAV } from "@/config/site";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="grain relative flex min-h-[90svh] items-center overflow-hidden bg-navy pt-28 text-paper" data-testid="not-found-page">
      <Seo title="Page Not Found | First Responders Foundation" description="The page you were looking for could not be found." path="/404" noindex />
      <span className="outline-num pointer-events-none absolute -right-8 bottom-0 select-none text-[16rem] md:text-[30rem]" aria-hidden="true">404</span>
      <div className="container-x relative">
        <p className="eyebrow eyebrow-light">Page not found</p>
        <h1 className="mt-6 max-w-3xl text-4xl font-black uppercase leading-[1.02] tracking-tight text-paper sm:text-5xl lg:text-6xl">This call went to the wrong address.</h1>
        <p className="mt-6 max-w-xl text-[#C9D4DF]">The page you are looking for may have moved or no longer exists. These links will get you back on route.</p>
        <div className="mt-10"><CtaLink to="/" variant="btn-gold" testId="not-found-home-button">Return Home</CtaLink></div>
        <ul className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-sm">
          {NAV.slice(1).map((n) => (
            <li key={n.to}><Link to={n.to} className="link-underline text-paper/90 hover:text-paper">{n.label}</Link></li>
          ))}
        </ul>
      </div>
    </section>
  );
}
